import { useBreakpoint } from '@one-thd/sui-atomic-components';

const SLIDES_PER_KEY = {
  minWidthMedium: {
    4: 2,
    6: 3,
    8: 4,
    12: 5,
  },
  minWidthLarge: {
    4: 2,
    6: 4,
    8: 5,
    12: 7,
  }
};

export const useSlidesPer = (renderWidths) => {
  const { lesser: isMobile } = useBreakpoint('lg');
  const { greater: isDesktop } = useBreakpoint('md');

  const safeRenderWidths = renderWidths;

  if (!safeRenderWidths) {
    return null;
  }

  let windowWidth;
  if (isMobile) {
    windowWidth = 'maxWidthMedium';
  } else if (isDesktop) {
    windowWidth = 'minWidthLarge';
  } else {
    windowWidth = 'minWidthMedium';
  }

  return windowWidth === 'maxWidthMedium'
    ? null
    : SLIDES_PER_KEY[windowWidth][+safeRenderWidths[windowWidth]];
};